<p-card header="Sort Line Inventory">
  <p-table [value]="sortLineInventoryItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>Product<span class="required">*</span></th>
        <th>Pieces<span class="required">*</span></th>
        <th>Delete</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
      <tr [formGroup]="rowData">
        <td>
          <p-dropdown
            [options]="products"
            formControlName="productId"
            appendTo="body"
            name="product"
            [required]
            [filter]="true"
            [editable]="false"
            [resetFilterOnHide]="true">
          </p-dropdown>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="pieces1"
            style="width:100%"
            name="pieces"
            required
            lib-numeric>
        </td>
        <td>
          <confirmation-button
            [iconsOnly]="true"
            actionIcon="pi pi-times"
            actionText="Delete"
            confirmIcon="pi pi-times"
            confirmText="Delete"
            cancelIcon="pi pi-minus-circle"
            cancelText="Cancel"
            [disabled]="rowData.disabled"
            (actionConfirmed)="deleteSortLine(rowData)">
          </confirmation-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="3" class="centered">
          No data available
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-rowData>
      <tr [formGroup]="sortLineInventoryForm">
        <td>
          <p-dropdown [options]="products" [required]
              placeholder="-- Select Product --" inputId="productID" formControlName="productId" appendTo="body"
              class="form-control" name="product" [filter]="true" [editable]="false" [resetFilterOnHide]="true">
          </p-dropdown>
          <error-block [field]="sortLineInventoryForm.controls.productId" [messages]="{
            required: 'Product is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="pieces" required name="pieces" class="form-control" formControlName="pieces1"/>
          <error-block [field]="sortLineInventoryForm.controls.pieces1" [messages]="{
            required: 'Pieces is required.'
          }">
          </error-block>
        </td>
        <td>
          <button type="button" pButton
            icon="pi pi-plus"
            iconPos="left"
            (click)="createSortLine();"
            label="Add"
            [disabled]="sortLineInventoryForm.disabled"
            [ngClass]="{ 'p-state-disabled': !sortLineInventoryForm.valid }">
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
